import React from 'react';
import {MesoAds} from '@homeaway/react-meso-ads';

export const MesoAdsCL = ({position}) => {
    let adsSlots = [];

    if (position === 4) {
        adsSlots = ['CL1', 'CL2', 'CL3'];
    } else if (position === 9) {
        adsSlots = ['CL4', 'CL5', 'CL6'];
    } else if (position === 14) {
        adsSlots = ['CL7', 'CL8', 'CL9'];
    }

    return adsSlots.map((slot) => <MesoAds slot={slot} key={slot} />);
};
